(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["th-custom-size"] && !Shopify.designMode) return;
  try {
    class HCCustomSize extends HTMLElement {
    connectedCallback() {
      if (this.closest('quick-add-modal')) { this.remove(); return; }
      this.trigger = this.querySelector('[data-th-custom-trigger]');
      this.panel = this.querySelector('[data-th-custom-panel]');
      this.width = this.querySelector('[data-th-custom-width]');
      this.height = this.querySelector('[data-th-custom-height]');
      this.result = this.querySelector('[data-th-custom-result]');
      this.areaOut = this.querySelector('[data-th-custom-area]');
      this.priceOut = this.querySelector('[data-th-custom-price]');
      this.errorOut = this.querySelector('[data-th-custom-error]');
      this.note = this.querySelector('[data-th-custom-note]');
      this.materialField = this.querySelector('[data-th-selected-material]');
      this.cta = this.querySelector('[data-th-custom-cta]');
      this.cartBtn = this.querySelector('[data-th-custom-cart]');
      this.stdBtn = this.querySelector('[data-th-custom-std]');
      if (this.cartBtn) this.cartBtn.addEventListener('click', this.onAddToCart);
      if (this.stdBtn) this.stdBtn.addEventListener('click', this.onPickStd);
      this.hint = this.querySelector('[data-th-custom-hint]');

      this.rates = {};
      for (const pair of (this.dataset.rates || '').split(',')) {
        const [key, value] = pair.split(':');
        if (key) this.rates[key] = Number(value);
      }

      this.trigger.addEventListener('click', this.onToggle);
      this.width.addEventListener('input', this.calculate);
      this.height.addEventListener('input', this.calculate);
      this.root = this.closest('product-info') || document;
      this.root.addEventListener('change', this.onMaterialChange);
      this.syncMaterial();
    }

    disconnectedCallback() {
      this.trigger.removeEventListener('click', this.onToggle);
      this.width.removeEventListener('input', this.calculate);
      this.height.removeEventListener('input', this.calculate);
      this.root.removeEventListener('change', this.onMaterialChange);
      if (this.cartBtn) this.cartBtn.removeEventListener('click', this.onAddToCart);
      if (this.stdBtn) this.stdBtn.removeEventListener('click', this.onPickStd);
    }

    onToggle = () => {
      const open = this.trigger.getAttribute('aria-expanded') !== 'true';
      this.trigger.setAttribute('aria-expanded', String(open));
      this.panel.hidden = !open;
      if (open) this.width.focus();
    };

    onMaterialChange = (event) => {
      if (event.target.matches && event.target.matches('.th-material__input')) this.syncMaterial();
    };

    syncMaterial() {
      const checked = this.root.querySelector('.th-material__input:checked');
      this.material = (checked && checked.dataset.materialKey) || this.dataset.productMaterial || Object.keys(this.rates)[0];
      if (this.materialField) this.materialField.value = this.material || '';
      this.calculate();
    }

    findStd(w, h) {
      const inputs = this.root.querySelectorAll('.th-size__input');
      for (const input of inputs) {
        const m = /^(\d+)\s*x\s*(\d+)/i.exec(input.value || '');
        if (!m) continue;
        const a = Number(m[1]), b = Number(m[2]);
        if ((a === w && b === h) || (a === h && b === w)) {
          const label = input.nextElementSibling;
          const priceEl = label && label.querySelector('.th-size__price');
          return { input, code: `${a}x${b}`, price: priceEl ? priceEl.textContent.trim() : '', disabled: input.classList.contains('disabled') };
        }
      }
      return null;
    }

    // En kucuk standart olcunun (80x120) fiyati: 1 m2 altindaki ozel olculerde taban.
    smallestStd() {
      let best = null;
      for (const input of this.root.querySelectorAll('.th-size__input')) {
        const m = /^(\d+)\s*x\s*(\d+)/i.exec(input.value || '');
        if (!m) continue;
        const a = Number(m[1]) * Number(m[2]);
        const label = input.nextElementSibling;
        const priceEl = label && label.querySelector('.th-size__price');
        const num = priceEl ? Number((priceEl.textContent || '').replace(/[^\d,]/g, '').replace(',', '.')) : NaN;
        if (!num) continue;
        if (!best || a < best.a) best = { a, price: num, code: `${m[1]}x${m[2]}` };
      }
      return best;
    }

    onPickStd = () => {
      const s = this.std;
      if (!s || !s.input) return;
      if (!s.input.checked) s.input.click();
      const box = s.input.closest('.th-size') || s.input;
      if (box.scrollIntoView) box.scrollIntoView({ block: 'center', behavior: 'smooth' });
    };

    roundToEndIn9(raw) {
      const n = Math.floor(raw + 0.5);
      const k = Math.floor((n - 5) / 10);
      return Math.max(10 * k + 9, 9);
    }

    formatMoney(amount) {
      const format = this.dataset.moneyFormat || '__AMT2__';
      const withSeparators = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
      const plain = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(amount);
      return format.replace(/__AMT2__/g, withSeparators).replace(/__AMT0__/g, plain);
    }

    setNote(std) {
      if (!this.note) return;
      this.note.textContent = std ? this.note.dataset.standart : this.note.dataset.ozel;
      this.note.classList.toggle('th-custom__note--std', !!std);
      if (this.result) this.result.classList.toggle('th-custom__result--std', !!std);
    }

    hideActions() {
      if (this.cta) { this.cta.hidden = true; this.cta.setAttribute('aria-disabled', 'true'); this.cta.removeAttribute('href'); }
      if (this.cartBtn) this.cartBtn.hidden = true;
      if (this.stdBtn) this.stdBtn.hidden = true;
    }

    clear(message) {
      this.std = null;
      this.areaOut.textContent = '';
      this.priceOut.textContent = '';
      this.errorOut.hidden = !message;
      this.errorOut.textContent = message || '';
      this.setNote(false);
      this.hideActions();
      if (this.hint) this.hint.hidden = false;
    }

    calculate = () => {
      const w = Number(this.width.value);
      const h = Number(this.height.value);
      if (!w || !h) return this.clear('');

      const minW = Number(this.dataset.minWidth), maxW = Number(this.dataset.maxWidth);
      const minH = Number(this.dataset.minHeight), maxH = Number(this.dataset.maxHeight);

      // Standart olcu ise onun fiyati (aralik disi olsa bile, orn. 220x360).
      const std = this.findStd(w, h);
      if (std && std.price && !std.disabled) {
        this.std = std;
        this.areaOut.textContent = `Standart ölçü · ${std.code} cm`;
        this.priceOut.textContent = std.price;
        this.errorOut.hidden = true;
        this.setNote(true);
        this.hideActions();
        if (this.stdBtn) this.stdBtn.hidden = false;
        if (this.hint) this.hint.hidden = true;
        return;
      }
      this.std = null;
      if (this.stdBtn) this.stdBtn.hidden = true;

      if (w < minW || w > maxW || h < minH || h > maxH) {
        return this.clear(this.errorOut.dataset.rangeMessage || '');
      }

      const rate = this.rates[this.material];
      if (!rate) return this.clear('');

      // Asgari fiyat: 1 m2 altinda en kucuk standart olcunun (80x120) fiyati.
      const area = (w * h) / 10000;
      let price = this.roundToEndIn9(area * rate);
      let floored = false;
      if (area < 1) {
        const small = this.smallestStd();
        const floor = small ? small.price : this.roundToEndIn9(rate);
        if (price < floor) { price = floor; floored = true; }
      }

      this.areaOut.textContent = floored ? `${area.toFixed(2)} m² · asgari fiyat` : `${area.toFixed(2)} m²`;
      this.priceOut.textContent = this.formatMoney(price);
      this.errorOut.hidden = true;
      this.setNote(false);

      this.updateOrderLink(w, h, area, price);

      this.dispatchEvent(new CustomEvent('hc:custom-size-change', { bubbles: true, detail: { width: w, height: h, area, material: this.material, price } }));
    };

    showCartButton() {
      if (!this.cartBtn) return false;
      const id = (this.dataset.customVariantId || '').trim();
      this.cartBtn.hidden = !id;
      return Boolean(id);
    }

    onAddToCart = async () => {
      const id = (this.dataset.customVariantId || '').trim();
      if (!id || this.busy) return;
      const w = Number(this.width.value), h = Number(this.height.value);
      if (!w || !h) return;
      this.busy = true;
      const label = this.cartBtn.textContent;
      this.cartBtn.disabled = true;
      this.cartBtn.textContent = this.dataset.cartBusy || label;
      try {
        const properties = { _ozel_olcu: 'true', En: String(Math.round(w)), Boy: String(Math.round(h)), Malzeme: this.material === 'sonil' ? 'Şönil' : 'Bambu' };
        const title = this.dataset.productTitle;
        if (title) properties['Desen'] = title;
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties }] }) });
        if (!res.ok) throw new Error('sepete eklenemedi');
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        window.location.href = '/cart';
      } catch (e) {
        this.errorOut.hidden = false;
        this.errorOut.textContent = this.dataset.cartError || 'Sepete eklenemedi.';
      } finally {
        this.busy = false;
        this.cartBtn.disabled = false;
        this.cartBtn.textContent = label;
      }
    };

    updateOrderLink(w, h, area, price) {
      if (!this.cta) return;
      const number = this.dataset.waNumber;
      if (!number) { this.cta.hidden = true; return; }
      const lines = [
        this.dataset.productTitle || '',
        this.dataset.productUrl || '',
        '',
        `${this.dataset.waSizeLabel}: ${w}x${h} cm (${area.toFixed(2)} m²)`,
        `${this.dataset.waPriceLabel}: ${this.formatMoney(price)}`,
        '',
        this.dataset.waIntro || '',
      ].filter((line, i) => line !== '' || i > 0);
      this.cta.href = `https://wa.me/${number}?text=${encodeURIComponent(lines.join('\n'))}`;
      this.cta.hidden = false;
      this.cta.setAttribute('aria-disabled', 'false');
      if (this.hint) this.hint.hidden = true;
      this.showCartButton();
    }
  }

  if (!customElements.get('th-custom-size')) {
    customElements.define('th-custom-size', HCCustomSize);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["th-delivery-countdown"] && !Shopify.designMode) return;
  try {
    class HCCountdown extends HTMLElement {
    connectedCallback() {
      this.start(parseInt(this.dataset.seconds, 10));
    }

    start(sec) {
      clearInterval(this.timer);
      this.remaining = sec;
      if (!Number.isFinite(this.remaining) || this.remaining <= 0) { this.textContent = ''; return; }
      this.render();
      this.timer = setInterval(() => {
        this.remaining -= 1;
        if (this.remaining <= 0) {
          clearInterval(this.timer);
          const box = this.closest('[data-th-teslim]');
          if (box && box.thHesapla) { box.thHesapla(); } else { this.textContent = ''; }
          return;
        }
        if (this.remaining % 60 === 59) this.render();
      }, 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    render() {
      const h = Math.floor(this.remaining / 3600);
      const m = Math.floor((this.remaining % 3600) / 60);
      const parts = [];
      if (h > 0) parts.push(`${h} ${this.dataset.hourLabel}`);
      parts.push(`${m} ${this.dataset.minuteLabel}`);
      this.textContent = parts.join(' ');
    }
  }

  if (!customElements.get('th-countdown')) {
    customElements.define('th-countdown', HCCountdown);
  }

  // r33: önbellekten gelen sayfada Liquid'in 'now' değeri eski olabilir.
  // Aynı kural burada, İstanbul saatine göre yeniden uygulanır.
  (function () {
    function istanbul(ms) {
      // Türkiye 2016'dan beri yıl boyu UTC+3.
      const d = new Date(ms + 3 * 3600 * 1000);
      return { y: d.getUTCFullYear(), mo: d.getUTCMonth(), d: d.getUTCDate(), w: d.getUTCDay(), h: d.getUTCHours(), mi: d.getUTCMinutes(), s: d.getUTCSeconds() };
    }
    function iso(t) { return t.y + '-' + String(t.mo + 1).padStart(2, '0') + '-' + String(t.d).padStart(2, '0'); }

    function hesapla(box) {
      const tatil = (box.dataset.tatil || '').split(',');
      const kesim = parseInt(box.dataset.kesim, 10) || 0;
      const isg = parseInt(box.dataset.isGunu, 10) || 3;
      const aylar = (box.dataset.aylar || '').split(',').map((s) => s.trim());
      const gunler = (box.dataset.gunler || '').split(',').map((s) => s.trim());
      const simdi = Date.now();
      const t = istanbul(simdi);
      const isGunu = (x) => x.w !== 0 && x.w !== 6 && tatil.indexOf(iso(x)) === -1;

      const kalan = kesim * 3600 - (t.h * 3600 + t.mi * 60 + t.s);
      const once = isGunu(t) && kalan > 0;
      let bas = once ? 1 : 2;
      if (!isGunu(t)) bas = 1;

      let say = 0, hedef = null;
      for (let i = 0; i < 41; i++) {
        const g = istanbul(simdi + (bas + i) * 86400000);
        if (isGunu(g)) { say++; if (say >= isg) { hedef = g; break; } }
      }
      if (!hedef) return;

      const etiket = hedef.d + ' ' + (aylar[hedef.mo] || '') + ' ' + (gunler[hedef.w] || '');
      const lead = box.querySelector('.th-delivery__lead');
      const tarih = box.querySelector('.th-delivery__date');
      if (tarih) tarih.textContent = (box.dataset.tarih || '[[d]]').replace('[[d]]', etiket);
      if (!lead) return;
      let sayac = lead.querySelector('th-countdown');
      if (once) {
        if (!sayac) {
          lead.textContent = '';
          sayac = document.createElement('th-countdown');
          sayac.className = 'th-delivery__timer';
          sayac.dataset.hourLabel = box.dataset.hourLabel || 'saat';
          sayac.dataset.minuteLabel = box.dataset.minuteLabel || 'dakika';
          lead.appendChild(sayac);
          lead.appendChild(document.createTextNode(' ' + (box.dataset.icinde || '')));
        }
        if (sayac.start) sayac.start(kalan); else sayac.dataset.seconds = kalan;
      } else if (sayac || lead.textContent.trim() !== (box.dataset.sonra || '').trim()) {
        lead.textContent = box.dataset.sonra || '';
      }
    }

    function kur() {
      document.querySelectorAll('[data-th-teslim]').forEach((box) => {
        box.thHesapla = () => hesapla(box);
        hesapla(box);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kur); else kur();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["th-design-upload"] && !Shopify.designMode) return;
  try {
    // Dosya secimini gosterir, boyutu kontrol eder ve zorunluysa
  // dosyasiz sepete eklemeyi engeller.
  //
  // Dawn'in urun formunda `novalidate` var, dolayisiyla tarayicinin
  // kendi `required` kontrolu calismiyor; dogrulama burada yapiliyor.
  class HCDesignUpload extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-th-upload-input]');
      this.fileOut = this.querySelector('[data-th-upload-file]');
      this.errorOut = this.querySelector('[data-th-upload-error]');
      if (!this.input) return;

      this.required = this.dataset.required === 'true';
      this.maxBytes = Number(this.dataset.maxBytes) || 0;

      this.input.addEventListener('change', this.onChange);

      // Form bu bilesenin disinda; id ile baglandigi icin elle bulunuyor.
      this.form = this.input.form || document.getElementById(this.input.getAttribute('form'));
      if (this.form) this.form.addEventListener('submit', this.onSubmit, true);
    }

    disconnectedCallback() {
      if (this.input) this.input.removeEventListener('change', this.onChange);
      if (this.form) this.form.removeEventListener('submit', this.onSubmit, true);
    }

    showError(message) {
      this.errorOut.textContent = message;
      this.errorOut.hidden = !message;
    }

    onChange = () => {
      const file = this.input.files && this.input.files[0];
      if (!file) {
        this.classList.remove('th-upload--filled');
        this.fileOut.hidden = true;
        this.showError('');
        return;
      }

      if (this.maxBytes && file.size > this.maxBytes) {
        this.input.value = '';
        this.classList.remove('th-upload--filled');
        this.fileOut.hidden = true;
        this.showError(this.dataset.errorSize);
        return;
      }

      const kb = file.size / 1024;
      const size = kb > 1024 ? `${(kb / 1024).toFixed(1)} MB` : `${Math.round(kb)} KB`;
      this.fileOut.textContent = `${file.name} · ${size}`;
      this.fileOut.hidden = false;
      this.classList.add('th-upload--filled');
      this.showError('');
    };

    onSubmit = (event) => {
      if (!this.required) return;
      if (this.input.files && this.input.files.length) return;

      // Capture asamasinda durduruluyor ki Dawn'in submit dinleyicisi
      // hic calismasin ve sepete ekleme baslamasin.
      event.preventDefault();
      event.stopImmediatePropagation();
      this.showError(this.dataset.errorRequired);
      this.input.focus();
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
  }

  if (!customElements.get('th-design-upload')) {
    customElements.define('th-design-upload', HCDesignUpload);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["th-promo-box"] && !Shopify.designMode) return;
  try {
    class HCPromoBox extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-th-copy]');
      if (!this.button) return;
      this.textEl = this.querySelector('.th-promo__code-text');
      this.original = this.textEl.textContent;
      this.button.addEventListener('click', this.onCopy);
    }
    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onCopy);
      clearTimeout(this.resetTimer);
    }
    onCopy = async () => {
      const code = this.button.dataset.thCopy;
      try { await navigator.clipboard.writeText(code); } catch (e) {
        const tmp = document.createElement('textarea');
        tmp.value = code; tmp.setAttribute('readonly', ''); tmp.style.position = 'absolute'; tmp.style.left = '-9999px';
        document.body.appendChild(tmp); tmp.select();
        try { document.execCommand('copy'); } catch (err) {}
        document.body.removeChild(tmp);
      }
      this.classList.add('th-promo--copied');
      this.textEl.textContent = this.button.dataset.labelCopied;
      clearTimeout(this.resetTimer);
      this.resetTimer = setTimeout(() => { this.classList.remove('th-promo--copied'); this.textEl.textContent = this.original; }, 2000);
    };
  }
  if (!customElements.get('th-promo-box')) { customElements.define('th-promo-box', HCPromoBox); }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["th-size-dialog"] && !Shopify.designMode) return;
  try {
    class HCGuideRooms extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.th-guide__tab'));
      this.rooms = Array.from(this.querySelectorAll('.th-guide__room'));
      this.addEventListener('click', (e) => {
        var tab = e.target.closest('.th-guide__tab');
        if (!tab) return;
        var key = tab.dataset.room;
        this.tabs.forEach(function(t){ t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        this.rooms.forEach(function(r){ r.hidden = r.dataset.room !== key; });
      });
    }
  }
  if (!customElements.get('th-guide-rooms')) { customElements.define('th-guide-rooms', HCGuideRooms); }

  class HCSizeDialog extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-th-size-dialog]');
      this.openers = document.querySelectorAll('[data-th-size-open]');
      this.closer = this.querySelector('[data-th-size-close]');
      if (!this.dialog) return;
      this.onOpen = () => { this.lastFocused = document.activeElement; this.dialog.showModal(); };
      this.onClose = () => this.dialog.close();
      this.openers.forEach((b) => b.addEventListener('click', this.onOpen));
      if (this.closer) this.closer.addEventListener('click', this.onClose);
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('close', () => { if (this.lastFocused && this.lastFocused.focus) this.lastFocused.focus(); });
    }
  }
  if (!customElements.get('th-size-dialog')) { customElements.define('th-size-dialog', HCSizeDialog); }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["th-sticky-atc"] && !Shopify.designMode) return;
  try {
    // Asıl sepete ekle düğmesi görüş alanından çıkınca çubuğu gösterir.
  // Scroll dinlemek yerine IntersectionObserver kullanılıyor: ana iş
  // parçacığını meşgul etmiyor ve CLS üretmiyor.
  class HCStickyAtc extends HTMLElement {
    connectedCallback() {
      const scope = this.closest('product-info') || document;
      this.anchor = scope.querySelector('.product-form__buttons') || scope.querySelector('[name="add"]');

      if (!this.anchor || !('IntersectionObserver' in window)) return;

      this.hidden = false;
      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.classList.toggle('th-sticky--visible', !entry.isIntersecting);
        },
        { rootMargin: '0px 0px -80px 0px' }
      );
      this.observer.observe(this.anchor);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('th-sticky-atc')) {
    customElements.define('th-sticky-atc', HCStickyAtc);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["th-sticky-filter"] && !Shopify.designMode) return;
  try {
    // Dugme kendi cekmecesini acmiyor: Dawn'in ozetine tikliyor.
  // Boylece odak tuzagi, geri tusu ve AJAX yenileme Dawn'da kaliyor.
  class HCStickyFilter extends HTMLElement {
    connectedCallback() {
      // Dugme #ProductGridContainer icinde basiliyor cunku aktif filtre
      // sayaci oradan geliyor: Dawn filtre degisiminde o kabin icerigini
      // bastan basiyor. Ama Dawn ayni kaba .scroll-trigger sinifiyla bir
      // transform veriyor ve transform position:fixed icin kapsayan blok
      // olusturuyor -- dugme viewporta degil kaba yapisiyordu, sayfanin
      // 950 piksel asagisinda kaliyordu.
      //
      // Cozum: isaretleme kapta kaliyor (sayac dogru), dugme body'ye
      // tasiniyor (konum dogru). Tasima disconnected + connected
      // tetikledigi icin bayrak gerekiyor, yoksa sonsuz donguye giriyor.
      if (this.dataset.portaled === 'true') {
        this.bind();
        return;
      }

      // Kap yeniden basildiginda eski kopya body'de kaliyor; yenisi
      // baglanirken onu temizliyor.
      document.querySelectorAll('th-sticky-filter[data-portaled="true"]').forEach((eski) => {
        if (eski !== this) eski.remove();
      });

      this.dataset.portaled = 'true';
      document.body.appendChild(this);
    }

    bind() {
      this.button = this.querySelector('[data-th-filter-open]');
      if (this.button) this.button.addEventListener('click', this.onOpen);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onOpen);
    }

    onOpen = () => {
      const summary = document.querySelector('.mobile-facets__open-wrapper');
      if (!summary) return;
      summary.click();
      // Odak cekmecenin icine gecsin; aksi halde klavye kullanicisi
      // acilan cekmecenin disinda kaliyor.
      requestAnimationFrame(() => {
        const first = document.querySelector('.mobile-facets__inner button, .mobile-facets__inner a, .mobile-facets__inner input');
        if (first) first.focus();
      });
    };
  }

  if (!customElements.get('th-sticky-filter')) {
    customElements.define('th-sticky-filter', HCStickyFilter);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["th-variant-picker"] && !Shopify.designMode) return;
  try {
    class HCMaterialSelect extends HTMLElement {
    connectedCallback() { this.addEventListener('change', this.onChange); this.sync(); }
    disconnectedCallback() { this.removeEventListener('change', this.onChange); }
    onChange = (event) => { if (event.target.matches('.th-material__input')) this.sync(); };
    sync() {
      const checked = this.querySelector('.th-material__input:checked');
      if (!checked) return;
      const active = checked.dataset.materialKey;
      this.querySelectorAll('.th-material__info').forEach((panel) => { panel.hidden = panel.dataset.materialKey !== active; });
    }
  }
  if (!customElements.get('th-material-select')) { customElements.define('th-material-select', HCMaterialSelect); }
  class HCSizeSelect extends HTMLElement { connectedCallback() {} }
  if (!customElements.get('th-size-select')) { customElements.define('th-size-select', HCSizeSelect); }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["th-whatsapp"] && !Shopify.designMode) return;
  try {
    class HCWhatsApp extends HTMLElement {
    connectedCallback() {
      this.bubble = this.querySelector('[data-th-wa-bubble]');
      if (!this.bubble) return;
      let dismissed = false;
      try { dismissed = localStorage.getItem('th-wa-dismissed') === '1'; } catch (e) {}
      if (dismissed) return;
      this.timer = setTimeout(() => { this.bubble.hidden = false; }, 1200);
      this.closeButton = this.querySelector('[data-th-wa-close]');
      if (this.closeButton) this.closeButton.addEventListener('click', this.onClose);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.closeButton) this.closeButton.removeEventListener('click', this.onClose);
    }
    onClose = () => {
      this.bubble.hidden = true;
      try { localStorage.setItem('th-wa-dismissed', '1'); } catch (e) {}
    };
  }
  if (!customElements.get('th-whatsapp')) { customElements.define('th-whatsapp', HCWhatsApp); }
  } catch(e) { console.error(e); }
})();

})();
